import React from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { InvoicingRun } from '../types/invoicing-run.type'
import { InvoicingRunReport } from './invoicing-run-report'

type Props = {
    run: InvoicingRun | null
    onClose: () => void
}

export const InvoicingRunReportDialog: React.FC<Props> = ({ run, onClose }) => {
    const { t } = useTranslation()
    return (
        <Dialog open={run !== null} onClose={onClose} maxWidth="lg" fullWidth>
            <DialogTitle>{t('INVOICING_RUN_REPORT', 'Invoicing run report')}</DialogTitle>
            <DialogContent>{run && <InvoicingRunReport run={run} />}</DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="contained" color="primary">
                    {t('TEXT_CLOSE', 'Close')}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
